import { gql, useMutation } from "@apollo/client";
import { ItemTypeEnum } from "@enums/ItemTypeEnum";
import { AnchorType } from "@types/AnchorType";
import { cartVar } from "./useCart";

export type AddItemAnchorInput = {
	cartId: string,
	product: {
		code: string,
		type: ItemTypeEnum,
		commercialPolicyId: number,
		amount: number,
		suggestions: {
			anchor: AnchorType[]
		}
	},
	overwrite: boolean
}

const CART = gql`
  mutation CartAddSuggestedAnchor($input: Cart_AddItemAnchorInput!) {
    Cart_addSuggestedAnchor(input: $input) {
      id
        customerCode
        industryCode
        status
        code
        userId
				grossPrice
				netPrice
				valid
				discountValue
				coupons
				shippingOrders {
					code
					paymentTerm
				}
				items {
					code
					amount
					totalDiscount
					commercialPolicyId
					type
					valid
					unitGrossPrice
					unitNetPrice
					grossPrice
					netPrice
					discountValue
					discount
					errors {
						type
						message
					}
					discountsTrace
					coupons {
						name
						percentage
					}
          			product {
						code
						description
						brand {
							id
							description
						}
						assortment {
							name
						}
					}
					suggestions{
						list{
							name
							code
							amount
						}
						anchor {
							anchorAmount
						}
					}
				}
    }
  }
`;

export const useAddSuggestedAnchor = () => {
	return useMutation(CART, {
		onCompleted(data) {
			if (data.Cart_addSuggestedAnchor) {
				cartVar(data.Cart_addSuggestedAnchor)
			}
		},
	});
};
